import React, { useEffect, useState } from "react";
import { getEventsinner } from "../Service/Api"; 
import { Link } from 'react-router-dom' 
import LazyLoad from "react-lazyload";
const Events = () => {
    useEffect(() => {
        // Set the page title
        document.title = 'Events - Presentation Convent School Delhi';
    }, []);
    const [data, setData] = useState([]);
    const [filterData, setFilteredData] = useState([]);
    const [selectedYear, setSelectedYear] = useState();
    const [selectedMonth, setSelectedMonth] = useState("All");
    const [monthOptions, setMonthOptions] = useState(["All"]);
    const [yearRanges, setYearRanges] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const Year = `${currentYear}`;
        setSelectedYear(Year);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            const galleryData = await getEventsinner();
            setData(galleryData);

            const uniqueYears = Array.from(
                new Set(galleryData.flatMap((item) => {
                    if (item.date) {
                        const year = new Date(item.date).getFullYear();
                        return [year];
                    } else {
                        return [];
                    }
                }))
            );
            const uniqueYearRanges = uniqueYears.map(year => `${year}`);
            uniqueYearRanges.sort((a, b) => b - a);
            setYearRanges(uniqueYearRanges);

            const uniqueMonths = Array.from(
                new Set(galleryData.flatMap((item) => {
                    if (item.date) {
                        const month = new Date(item.date).getMonth();
                        return [month];
                    } else {
                        return [];
                    }
                }))
            );
            const monthOptions = uniqueMonths.sort((a, b) => a - b).map(month => monthNames[month]);
            setMonthOptions(["All", ...monthOptions]);
        };
        fetchData();
    }, []);

    useEffect(() => {
        let filteredData = data;
        if (selectedYear !== "All") {
            filteredData = filteredData.filter((item) => {
                if (item.date && item.date.trim() !== "") {
                    const year = new Date(item.date).getFullYear();
                    return parseInt(selectedYear) === year;
                } else {
                    return false;
                }
            });
        }
        if (selectedMonth !== "All") {
            filteredData = filteredData.filter((item) => {
                if (item.date && item.date.trim() !== "") {
                    const month = new Date(item.date).getMonth();
                    return monthNames[month] === selectedMonth;
                } else {
                    return false;
                }
            });
        }
        if (searchQuery) {
            filteredData = filteredData.filter((item) =>
                item.title.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        // Sort the filtered data by month in descending order
        filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));
        setFilteredData(filteredData);
    }, [selectedYear, selectedMonth, searchQuery, data]);
    return (
        <>
            <div className="breadcrumb">
                <h2> Events</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Events</li>
                </ul>
            </div>
            <div className="inner_page">
                <div className="container">
                    <div className="row tabs-dynamic">
                        <div className="col-md-3">
                            <div className="count-val">
                                <p>Total Count:  {filterData.length}</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="month-selection">
                                <select
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(e.target.value)}
                                    className="yearSelection">
                                    <option value={"All"}>All</option>

                                    {yearRanges.map((yr) => (
                                        <option key={yr} value={yr}>{yr}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="month-selection">
                                <select
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                    className="monthSelect">
                                    {monthOptions.map((month, index) => (
                                        <option key={index} value={month}>{month}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="searchBox">
                                <input
                                    type="text"
                                    id="myInput"
                                    name="name"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    placeholder="Search Here.."
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row event_news_inner">
                        {filterData.length > 0 ? (
                            filterData.map((item, index) => (
                                <div className="col-lg-4 col-md-12" key={index}>
                                    <div className="event-inner"> 
                                        <div className="date_hidn">
                                            <LazyLoad>   {item.images.length > 0 ? (<img src={`https://webapi.entab.info/api/image/${item?.images}`} alt="Cannosa School, Lucknow" />) : (<img src="https://webapi.entab.info/api/image/SFSAP/public/Images/events.jpg" alt="Cannosa School, Lucknow" />)}</LazyLoad>
                                            {item.attachments > 0 && (<div class="attach_sec"><Link to={`https://webapi.entab.info/api/image/${item?.attachments}`} target="_blank"><i class="fa fa-paperclip" aria-hidden="true"></i></Link></div>)}
                                        </div>
                                        <div className="data_scrol">
                                            <h3>{item.title}</h3>
                                            <p>{item.description}</p>
                                        </div>
                                        <ul>
                                            <li><i class="bi bi-alarm-fill"></i> &nbsp;{item.time}</li>
                                            <li><i class="bi bi-calendar-range-fill"></i> &nbsp;{item.date}</li>
                                            <li><i class="bi bi-geo-alt-fill"></i> &nbsp; {item.venue}</li></ul>
                                    </div>
                                </div>
                            ))
                        ) : (

                            <div className="col-lg-4 col-md-12">
                                <div className="event-inner"> 
                                    <div className="date_hidn">
                                        <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/events.jpg" alt="Cannosa School, Lucknow" /></LazyLoad>
                                        <div class="attach_sec"><Link to="/" target="_blank"><i class="fa fa-paperclip" aria-hidden="true"></i></Link></div>
                                    </div>
                                    <div className="data_scrol">
                                        <h3>Events Heading - 1</h3>
                                        <p>Stay tuned for more information about latest updates.</p>

                                    </div>
                                    <ul><li><i class="bi bi-alarm-fill"></i> &nbsp;09:30</li>
                                    <li><i class="bi bi-calendar-range-fill"></i> &nbsp;01 Jun 2024</li>
                                    <li><i class="bi bi-geo-alt-fill"></i> &nbsp; School</li></ul>
                                </div>
                            </div>
                        )}


                    </div>
                </div>
            </div> 
        </>
    )
}

export default Events
